/**
 * Initialize lazy load instance
 * Performance: Guards against missing LazyLoad library
 */
function vzLazyLoadInit() {
  if (typeof LazyLoad === 'undefined') {
    console.warn('LazyLoad library not loaded');
    return;
  }
  window.vzLazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
    use_native: true // Use native lazy loading when available
  });
}

/**
 * Update lazy load instance
 * Performance: Guards against uninitialized instance
 */
function vzLazyLoadUpdate() {
  if (window.vzLazyLoadInstance && typeof window.vzLazyLoadInstance.update === 'function') {
    window.vzLazyLoadInstance.update();
  }
}
